import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import { DEMO_DATA } from '../services/excelService';

interface Linha {
  objetivo: string;
  formato: string;
  plataforma: string;
  estrategia: string;
  criativo: string;
  tipoCompra: string;
  tabelaPreco: string;
  tabelaPrecoBV?: string;
  investimentoMinimo: string;
}

interface ProgramaticaOpenData {
  Objetivo: string;
  Plataforma: string;
  Formatos: string;
  Estrategias: string;
  Compra: string;
  'CPM Estados e Brasil': number;
  'CPM Grandes Metropoles': number;
  'CPM Cidade Pequena': number;
  'Com BV até 10% - Estados e Brasil': number;
  'Com BV até 10% - Grandes Metrópoles': number;
  'Com BV até 10% - Cidades Pequenas': number;
}

// Import the LINHAS array from the correct location
const LINHAS: Linha[] = [
  { objetivo: 'Awareness', formato: 'CTV', plataforma: 'ShowHeroes', estrategia: 'CTV LG + TCL - Brasil', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 150,00', investimentoMinimo: 'R$ 45.000,00' },
  { objetivo: 'Awareness', formato: 'CTV', plataforma: 'Samsung', estrategia: 'CTV Samsung TV Plus  - Brasil', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 150,00', investimentoMinimo: 'R$ 45.000,00' },
  { objetivo: 'Awareness', formato: 'CTV', plataforma: 'Samsung', estrategia: 'CTV Samsung TV Plus  - Estados e Grandes Metrópoles', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 180,00', investimentoMinimo: 'R$ 45.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'ShowHeroes', estrategia: 'OTT - Brasil', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 120,00', investimentoMinimo: 'R$ 45.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Pluto TV / UOL', estrategia: 'OTT - Pluto TV', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 120,00', investimentoMinimo: 'R$ 45.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Direto', estrategia: 'Rotativo - Aberto BR', criativo: 'Vídeo 30s', tipoCompra: 'CPM', tabelaPreco: 'R$ 175,00', investimentoMinimo: 'R$ 300.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Direto', estrategia: 'Gênero do Conteúdo (mínimo 3)', criativo: 'Vídeo 30s', tipoCompra: 'CPM', tabelaPreco: 'R$ 201,25', investimentoMinimo: 'R$ 300.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Direto', estrategia: 'Top 10', criativo: 'Vídeo 30s', tipoCompra: 'CPM', tabelaPreco: 'R$ 245,00', investimentoMinimo: 'R$ 300.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Direto', estrategia: 'Idade e Gênero (binário)', criativo: 'Vídeo 30s', tipoCompra: 'CPM', tabelaPreco: 'R$ 220,00', investimentoMinimo: 'R$ 300.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Direto', estrategia: 'Geoloc (Apenas Estado)', criativo: 'Vídeo 30s', tipoCompra: 'CPM', tabelaPreco: 'R$ 192,50', investimentoMinimo: 'R$ 300.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Direto', estrategia: 'Primeira Impressão', criativo: 'Vídeo 30s', tipoCompra: 'CPM', tabelaPreco: 'R$ 350,00', investimentoMinimo: 'R$ 300.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Prog', estrategia: 'Aberto BR', criativo: 'Vídeo 10s', tipoCompra: 'CPM', tabelaPreco: 'R$ 116,00', investimentoMinimo: 'R$ 150.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Prog', estrategia: 'Aberto BR', criativo: 'Vídeo 15s', tipoCompra: 'CPM', tabelaPreco: 'R$ 154,67', investimentoMinimo: 'R$ 150.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Prog', estrategia: 'Aberto BR + Gênero de Conteúdo', criativo: 'Vídeo 10s', tipoCompra: 'CPM', tabelaPreco: 'R$ 127,60', investimentoMinimo: 'R$ 150.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Prog', estrategia: 'Aberto BR + Gênero de Conteúdo', criativo: 'Vídeo 15s', tipoCompra: 'CPM', tabelaPreco: 'R$ 170,13', investimentoMinimo: 'R$ 150.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Prog', estrategia: 'Estado ou Grandes Metrópoles', criativo: 'Vídeo 10s', tipoCompra: 'CPM', tabelaPreco: 'R$ 127,60', investimentoMinimo: 'R$ 150.000,00' },
  { objetivo: 'Awareness', formato: 'OTT', plataforma: 'Netflix Prog', estrategia: 'Estado ou Grandes Metrópoles', criativo: 'Vídeo 15s', tipoCompra: 'CPM', tabelaPreco: 'R$ 170,13', investimentoMinimo: 'R$ 150.000,00' },
  { objetivo: 'Awareness', formato: 'WhatsApp', plataforma: 'WhatsNow', estrategia: 'Abaixo de 20 mil disparos', criativo: 'Display ou Vídeo + Texto', tipoCompra: 'CPD', tabelaPreco: 'R$ 0,77', tabelaPrecoBV: 'R$ 0,92', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Awareness', formato: 'WhatsApp', plataforma: 'WhatsNow', estrategia: '20 mil a 30 mil disparos', criativo: 'Display ou Vídeo + Texto', tipoCompra: 'CPD', tabelaPreco: 'R$ 0,70', tabelaPrecoBV: 'R$ 0,84', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Awareness', formato: 'WhatsApp', plataforma: 'WhatsNow', estrategia: '31 mil a 200 mil disparos', criativo: 'Display ou Vídeo + Texto', tipoCompra: 'CPD', tabelaPreco: 'R$ 0,53', tabelaPrecoBV: 'R$ 0,64', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Awareness', formato: 'WhatsApp', plataforma: 'WhatsNow', estrategia: '201 mil a 600 mil disparos', criativo: 'Display ou Vídeo + Texto', tipoCompra: 'CPD', tabelaPreco: 'R$ 0,50', tabelaPrecoBV: 'R$ 0,60', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Awareness', formato: 'WhatsApp', plataforma: 'WhatsNow', estrategia: 'A partir de 600 mil disparos', criativo: 'Display ou Vídeo + Texto', tipoCompra: 'CPD', tabelaPreco: 'R$ 0,43', tabelaPrecoBV: 'R$ 0,52', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Awareness', formato: 'Áudio', plataforma: 'Spotify', estrategia: 'Segmentação demográfica e geográfica', criativo: 'Display', tipoCompra: 'CPM', tabelaPreco: 'R$ 49,20', tabelaPrecoBV: 'R$ 59,04', investimentoMinimo: 'R$ 25.000,00' },
  { objetivo: 'Awareness', formato: 'Áudio', plataforma: 'Spotify', estrategia: 'Segmentação demográfica e geográfica', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 150,37', tabelaPrecoBV: 'R$ 180,44', investimentoMinimo: 'R$ 25.000,00' },
  { objetivo: 'Awareness', formato: 'Áudio', plataforma: 'Spotify', estrategia: 'Segmentação demográfica e geográfica', criativo: 'Audio', tipoCompra: 'CPM', tabelaPreco: 'R$ 138,00', tabelaPrecoBV: 'R$ 165,60', investimentoMinimo: 'R$ 25.000,00' },
  { objetivo: 'Awareness', formato: 'Display', plataforma: 'Serasa', estrategia: 'Site & App Serasa', criativo: 'Display', tipoCompra: 'CPM', tabelaPreco: 'R$ 95,00', tabelaPrecoBV: 'R$ 110,00', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Consideração', formato: 'Push Notification', plataforma: 'Siprocal', estrategia: 'Push Notification (Contextual ou App Target) Com Imagem ou Apenas Texto', criativo: 'Display, Logo + Texto', tipoCompra: 'CPC', tabelaPreco: 'R$ 2,67', tabelaPrecoBV: 'R$ 3,20', investimentoMinimo: 'R$ 30.000,00' },
  { objetivo: 'Consideração', formato: 'Push Notification', plataforma: 'Hands', estrategia: 'Hands - Push Notification - Geotrack & Livetrack (Raios mais precisos em lista de endereços)', criativo: 'Display, Logo + Texto', tipoCompra: 'CPE', tabelaPreco: 'R$ 0,70', tabelaPrecoBV: 'R$ 0,85', investimentoMinimo: 'R$ 30.000,00' },
  { objetivo: 'Consideração', formato: 'Push Notification', plataforma: 'Hands', estrategia: 'Hands - Push Notification - Geotrack (Raios mais precisos em lista de endereços) + Relatório de Store Visits', criativo: 'Display, Logo + Texto', tipoCompra: 'CPE', tabelaPreco: 'R$ 1,00', tabelaPrecoBV: 'R$ 1,25', investimentoMinimo: 'R$ 30.000,00' },
  { objetivo: 'Consideração', formato: 'Web Push', plataforma: 'Pixel Roads', estrategia: 'País/Estado/Grandes Metrópoles', criativo: 'Display + Texto', tipoCompra: 'CPC', tabelaPreco: 'R$ 1,50', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Consideração', formato: 'Web Push', plataforma: 'Pixel Roads', estrategia: 'Pequenas Praças - Idealmente trabalhar com mais de uma', criativo: 'Display + Texto', tipoCompra: 'CPC', tabelaPreco: 'R$ 1,85', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Consideração', formato: 'Native', plataforma: 'Pixel Roads', estrategia: 'Native 3.0', criativo: 'Native - Imagem + Texto', tipoCompra: 'CPC', tabelaPreco: 'R$ 1,83', tabelaPrecoBV: 'R$ 2,20', investimentoMinimo: 'R$ 15.000,00' },
  { objetivo: 'Consideração', formato: 'Native', plataforma: 'Tinder', estrategia: 'Native Display Card (Square) - DV360 - PD', criativo: 'Display', tipoCompra: 'CPM', tabelaPreco: 'R$ 150,00', tabelaPrecoBV: 'R$ 204,23', investimentoMinimo: 'R$ 30.000,00' },
  { objetivo: 'Consideração', formato: 'Native', plataforma: 'Tinder', estrategia: 'Native Display Card - DV360 - PG', criativo: 'Display', tipoCompra: 'CPM', tabelaPreco: 'R$ 150,00', tabelaPrecoBV: 'R$ 204,23', investimentoMinimo: 'R$ 105.000,00' },
  { objetivo: 'Consideração', formato: 'Native', plataforma: 'Tinder', estrategia: 'Native Video Card - DV360 - PG', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 150,00', tabelaPrecoBV: 'R$ 204,23', investimentoMinimo: 'R$ 105.000,00' },
  { objetivo: 'Consideração', formato: 'Alto Impacto', plataforma: 'Seedtag', estrategia: 'Contextual Impact Display (CID)', criativo: 'Display', tipoCompra: 'CPM', tabelaPreco: 'R$ 75,60', tabelaPrecoBV: 'R$ 90,72', investimentoMinimo: 'R$ 34.000,00' },
  { objetivo: 'Consideração', formato: 'Alto Impacto', plataforma: 'Seedtag', estrategia: 'Contextual Engagement Display (CED)', criativo: 'Display', tipoCompra: 'CPM', tabelaPreco: 'R$ 73,07', tabelaPrecoBV: 'R$ 87,68', investimentoMinimo: 'R$ 34.000,00' },
  { objetivo: 'Consideração', formato: 'Alto Impacto', plataforma: 'Seedtag', estrategia: 'Contextual Frame Display (CFD)', criativo: 'Display', tipoCompra: 'CPM', tabelaPreco: 'R$ 94,50', tabelaPrecoBV: 'R$ 113,40', investimentoMinimo: 'R$ 34.000,00' },
  { objetivo: 'Consideração', formato: 'Alto Impacto', plataforma: 'Seedtag', estrategia: 'Contextual Branded Video (CBV)', criativo: 'Vídeo', tipoCompra: 'CPV', tabelaPreco: 'R$ 0,60', tabelaPrecoBV: 'R$ 0,72', investimentoMinimo: 'R$ 34.000,00' },
  { objetivo: 'Consideração', formato: 'Alto Impacto', plataforma: 'Seedtag', estrategia: 'Contextual Engagement Video (CEV)', criativo: 'Vídeo', tipoCompra: 'CPV', tabelaPreco: 'R$ 0,77', tabelaPrecoBV: 'R$ 0,92', investimentoMinimo: 'R$ 34.000,00' },
  { objetivo: 'Consideração', formato: 'Alto Impacto', plataforma: 'Seedtag', estrategia: 'Contextual Outstream Video (COV)', criativo: 'Vídeo', tipoCompra: 'CPV', tabelaPreco: 'R$ 0,60', tabelaPrecoBV: 'R$ 0,72', investimentoMinimo: 'R$ 34.000,00' },
  { objetivo: 'Consideração', formato: 'Alto Impacto', plataforma: 'Seedtag', estrategia: 'Contextual Native', criativo: 'Display', tipoCompra: 'CPC', tabelaPreco: 'R$ 9,60', tabelaPrecoBV: 'R$ 11,52', investimentoMinimo: 'R$ 34.000,00' },
  { objetivo: 'Consideração', formato: 'Alto Impacto', plataforma: 'Vidoomy', estrategia: 'Vídeo Enriquecido', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 90,00', tabelaPrecoBV: 'R$ 130,00', investimentoMinimo: 'R$ 100.000,00' },
  { objetivo: 'Consideração', formato: 'In Game', plataforma: 'Etermax', estrategia: 'Playable Ads', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 208,01', investimentoMinimo: 'R$ 105.000,00' },
  { objetivo: 'Consideração', formato: 'In Game', plataforma: 'Etermax', estrategia: 'Interstitial', criativo: 'Display ou Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 79,42', investimentoMinimo: 'R$ 20.000,00' },
  { objetivo: 'Consideração', formato: 'In Game', plataforma: 'Etermax', estrategia: 'Rewarded Vídeo', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 147,50', investimentoMinimo: 'R$ 20.000,00' },
  { objetivo: 'Consideração', formato: 'In Game', plataforma: 'Etermax', estrategia: 'Banner', criativo: 'Display', tipoCompra: 'CPM', tabelaPreco: 'R$ 45,38', investimentoMinimo: 'R$ 20.000,00' },
  { objetivo: 'Consideração', formato: 'In Game', plataforma: 'Adsmovil', estrategia: 'Interstitial', criativo: 'Display ou Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 60,00', tabelaPrecoBV: 'R$ 80,00', investimentoMinimo: 'R$ 20.000,00' },
  { objetivo: 'Consideração', formato: 'In Game', plataforma: 'Adsmovil', estrategia: 'Rewarded Vídeo', criativo: 'Vídeo', tipoCompra: 'CPM', tabelaPreco: 'R$ 120,00', tabelaPrecoBV: 'R$ 160,00', investimentoMinimo: 'R$ 20.000,00' },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Criador: React.FC = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Criador de Estratégias
      </Typography>
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Programática Especial" {...a11yProps(0)} />
          <Tab label="Programática Open" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Objetivo</TableCell>
                <TableCell>Formato</TableCell>
                <TableCell>Plataforma</TableCell>
                <TableCell>Estratégia</TableCell>
                <TableCell>Criativo</TableCell>
                <TableCell>Tipo de Compra</TableCell>
                <TableCell>Preço</TableCell>
                <TableCell>Preço com BV</TableCell>
                <TableCell>Investimento Mínimo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {LINHAS.map((linha: Linha, index: number) => (
                <TableRow key={index}>
                  <TableCell>{linha.objetivo}</TableCell>
                  <TableCell>{linha.formato}</TableCell>
                  <TableCell>{linha.plataforma}</TableCell>
                  <TableCell>{linha.estrategia}</TableCell>
                  <TableCell>{linha.criativo}</TableCell>
                  <TableCell>{linha.tipoCompra}</TableCell>
                  <TableCell>{linha.tabelaPreco}</TableCell>
                  <TableCell>{linha.tabelaPrecoBV || '-'}</TableCell>
                  <TableCell>{linha.investimentoMinimo}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Objetivo</TableCell>
                <TableCell>Plataforma</TableCell>
                <TableCell>Formatos</TableCell>
                <TableCell>Estratégias</TableCell>
                <TableCell>Compra</TableCell>
                <TableCell>CPM Estados e Brasil</TableCell>
                <TableCell>CPM Grandes Metrópoles</TableCell>
                <TableCell>CPM Cidade Pequena</TableCell>
                <TableCell>Com BV até 10% - Estados e Brasil</TableCell>
                <TableCell>Com BV até 10% - Grandes Metrópoles</TableCell>
                <TableCell>Com BV até 10% - Cidades Pequenas</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {DEMO_DATA.map((row: ProgramaticaOpenData, index: number) => (
                <TableRow key={index}>
                  <TableCell>{row.Objetivo}</TableCell>
                  <TableCell>{row.Plataforma}</TableCell>
                  <TableCell>{row.Formatos}</TableCell>
                  <TableCell>{row.Estrategias}</TableCell>
                  <TableCell>{row.Compra}</TableCell>
                  <TableCell>{row['CPM Estados e Brasil'].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                  <TableCell>{row['CPM Grandes Metropoles'].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                  <TableCell>{row['CPM Cidade Pequena'].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                  <TableCell>{row['Com BV até 10% - Estados e Brasil'].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                  <TableCell>{row['Com BV até 10% - Grandes Metrópoles'].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                  <TableCell>{row['Com BV até 10% - Cidades Pequenas'].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </TabPanel>
    </Box>
  );
};

export default Criador; 